export const requiredErrorMessage = 'Obrigatório';
export const invalidEmail = 'E-mail inválido';
export const invalidPhone = 'Número inválido';
export const invalidCpf = 'CPF inválido';
export const invalidCnpj = 'Cnpj inválido';
export const invalidYear = 'Ano inválido';
export const invalidPositiveNumber = 'O valor precisa ser positivo';
export const invalidObjectId = 'Id inválido';
export const notValidValue = 'O valor não é válido';
export const genericInvalidMessage = 'Campo inválido';
